module.exports = __webpack_public_path__ + "static/img/SH.ccc9d2e7.jpeg";